import React, { useState } from 'react';
import { Box, Container, Typography, Tabs, Tab, Card, Fade } from '@mui/material';
import { Settings } from '@mui/icons-material';
import { Helmet } from 'react-helmet';
import CostCenterList from './CostCenterList';
import FinancialCategoryList from './FinancialCategoryList';
import RevenueSourceList from './RevenueSourceList';

const FinancialConfig = () => {
    const [tabValue, setTabValue] = useState(0);

    return (
        <>
            <Helmet>
                <title>Configurações - Bloco B3</title>
            </Helmet>
            <Box sx={{ bgcolor: '#F8FAFC', minHeight: '100vh' }}>
                <Container maxWidth="xl" sx={{ py: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                        <Settings sx={{ color: '#64748B', fontSize: 28 }} />
                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#1E293B' }}>
                            Configurações
                        </Typography>
                    </Box>

                    <Card
                        sx={{
                            border: '1px solid #E2E8F0',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                            borderRadius: 2,
                            overflow: 'hidden',
                        }}
                    >
                        <Tabs
                            value={tabValue}
                            onChange={(_event, newValue) => setTabValue(newValue)}
                            sx={{
                                bgcolor: '#fff',
                                px: 2,
                                '& .MuiTab-root': {
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '0.875rem',
                                    color: '#64748B',
                                    minHeight: 48,
                                    '&.Mui-selected': { color: '#3B82F6' },
                                },
                                '& .MuiTabs-indicator': { backgroundColor: '#3B82F6' },
                                borderBottom: '1px solid #E2E8F0',
                            }}
                        >
                            <Tab label="Centro de Custo" />
                            <Tab label="Categorias" />
                            <Tab label="Fonte de Recebimento" />
                        </Tabs>

                        {tabValue === 0 && (
                            <Fade in mountOnEnter unmountOnExit timeout={300}>
                                <Box>
                                    <CostCenterList />
                                </Box>
                            </Fade>
                        )}
                        {tabValue === 1 && (
                            <Fade in mountOnEnter unmountOnExit timeout={300}>
                                <Box>
                                    <FinancialCategoryList />
                                </Box>
                            </Fade>
                        )}
                        {tabValue === 2 && (
                            <Fade in mountOnEnter unmountOnExit timeout={300}>
                                <Box>
                                    <RevenueSourceList />
                                </Box>
                            </Fade>
                        )}
                    </Card>
                </Container>
            </Box>
        </>
    );
};

export default FinancialConfig;
